import React from "react";
import { Box, Typography } from "@mui/material";
import ModalShell from "../CollectionsTab/ModalShell";
import { collectionColors, font, subtitleSx } from "../CollectionsTab/tokens";

interface ConfirmMigrationDialogProps {
  open: boolean;
  organizationName: string;
  candidateCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmMigrationDialog: React.FC<ConfirmMigrationDialogProps> = ({
  open,
  organizationName,
  candidateCount,
  onClose,
  onConfirm,
}) => (
  <ModalShell
    open={open}
    onClose={onClose}
    title="Execute migration"
    subtitle={`${candidateCount} survey${candidateCount === 1 ? "" : "s"} in "${organizationName}" will each get a collection named after the survey, with the survey as its only variant.`}
    confirmLabel="Execute migration"
    onConfirm={onConfirm}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        padding: "12px",
        background: collectionColors.surfaceLight,
        borderRadius: "8px",
      }}
    >
      <Typography
        sx={{
          fontFamily: font,
          fontWeight: 500,
          fontSize: "13px",
          lineHeight: "18px",
          color: collectionColors.textPrimary,
        }}
      >
        What this does not change
      </Typography>
      <Typography sx={{ ...subtitleSx, fontSize: "13px", lineHeight: "18px" }}>
        No survey is modified, duplicated or deleted, and no version history changes. Only
        the collection layer above them is created. Surveys that already belong to a
        collection are skipped, so running this again is safe.
      </Typography>
    </Box>
  </ModalShell>
);

export default ConfirmMigrationDialog;
